import * as React from "react";
import { Textarea } from "@/shared/components/ui/textarea";
import { MagicFillFieldButton } from "./MagicFillFieldButton";
import { MagicFillFormType, MagicFillMetadata } from "./MagicFillButton";
import { cn } from "@/infrastructure/lib/utils";
import { useMagicFill } from "@/shared/contexts/MagicFillContext";

export interface TextareaWithMagicFillProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  formType: MagicFillFormType;
  fieldKey: string;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCurrentValues: () => Record<string, any>;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onMagicFillApply: (value: any) => void;
  onLoadingChange?: (isLoading: boolean) => void;
  metadata?: MagicFillMetadata;
  showMagicFill?: boolean;
}

export const TextareaWithMagicFill = React.forwardRef<
  HTMLTextAreaElement,
  TextareaWithMagicFillProps
>(
  (
    {
      formType,
      fieldKey,
      getCurrentValues,
      onMagicFillApply,
      onLoadingChange,
      metadata,
      showMagicFill = true,
      className,
      disabled,
      ...props
    },
    ref
  ) => {
    const { isGlobalLoading, isFieldLoading } = useMagicFill();
    const isLoading = isGlobalLoading || isFieldLoading(fieldKey);

    return (
      <div className="relative">
        <Textarea
          ref={ref}
          fieldKey={fieldKey}
          className={cn("pr-10 resize-y", className)}
          disabled={disabled}
          {...props}
        />
        {showMagicFill && !disabled && !isLoading && (
          <MagicFillFieldButton
            formType={formType}
            fieldKey={fieldKey}
            getCurrentValues={getCurrentValues}
            metadata={metadata}
            className="absolute right-2 top-2 translate-y-0"
            onApplySuggestion={onMagicFillApply}
            onLoadingChange={onLoadingChange}
          />
        )}
      </div>
    );
  }
);

TextareaWithMagicFill.displayName = "TextareaWithMagicFill";
